import React from 'react';
import './badge.css';

export const Badge = React.forwardRef(({ children, variant = 'default', icon, className = '', onClick, ...props }, ref) => {
  return (
    <span 
      ref={ref}
      className={`badge ${variant} ${className}`}
      onClick={onClick}
      style={onClick ? { cursor: 'pointer' } : {}}
      {...props}
    >
      {icon && <span className="badge-icon">{icon}</span>}
      {children}
    </span>
  );
}); 